import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import SearchInput from "../../../../customComponents/CustomSearch/SearchInput";
import Loader from "../../../../customComponents/CustomLoader";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
// import axiosInstance from '../../../services/api/API';
// import SearchInput from '../../../customComponents/CustomSearch/SearchInput';
// import Loader from '../../../customComponents/CustomLoader';
// import ROUTES_NAVIGATION from '../../../../routes/routes';
// import searchIcon from "../../../../Assets/icons/searchicon.svg"
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import CustomTable from "../../../../customComponents/CustomTable";
// import CustomTable from '../../../customComponents/CustomTable';
import eyeIcon from "../../../../../Assets/icons/eye 1.svg";
import { IoMdClose } from "react-icons/io";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import download from "../../../../../Assets/icons/download.svg";
import mailIcon from "../../../../../Assets/icons/mailIcon.svg"
import * as base64 from "base-64";
// import editIcon from "../../../../Assets/icons/Un-Checkbox.svg"
// import CustomTable from '../../../customComponents/CustomTable';
// import eyeIcon from "../../../../Assets/icons/eye 1.svg"
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { showAlert } from "../../../../customComponents/CustomSweetAlert/ShowAlert";

const AdminCustomerPurchaseOrder = () => {
  const [productData, setProductData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalInactive, setTotalInactive] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [filters, setFilters] = useState({});

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const dealer_id = localStorage.getItem("dealerId");

  const formatDateToDDMMYYYY = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const fetchProductList = async (currentPage = 0) => {
    const allfilteredData = filters;
    try {
      const formattedStartDate = formatDateToDDMMYYYY(
        allfilteredData?.fromDate
      );
      const formattedEndDate = formatDateToDDMMYYYY(allfilteredData?.toDate);

      setLoading(true);
      const response = await axiosInstance.post(
        "/customer-po/customer-po-list",
        {
          orderBy: "postockinsr_id desc",
          page: 0,
          pageSize: 10000, // Fetch all data
          searchText: searchTerm,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          dealer_id: null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const allData = response?.data?.data?.data || [];
      const filteredData = allData.filter(item => item.vin_no && item.vin_no.trim() !== "");

      const totalFiltered = filteredData.length;
      setTotalRecords(totalFiltered);
      setTotalPages(Math.ceil(totalFiltered / 10));

      const start = currentPage * 10;
      const end = start + 10;
      const pageData = filteredData.slice(start, end);

      const formattedData = pageData.map((item, index) => ({
        ...item,
        "Sr No.": index + 1 + currentPage * 10,
        serial_no: item.serial_no || "--",

        battery_no: item.battery_no
       ? Array.isArray(item.battery_no)
       ? item.battery_no.join(", ")
       : item.battery_no
       : "--",
       
       motor_no: item.motor_no
       ? Array.isArray(item.motor_no)
       ? item.motor_no.join(", ")
       : item.motor_no
       : "--",
      }));

      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      setProductData(formattedData);
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      setLoading(false);
    }
  };

  const downloadExcel = async () => {
    try {
      const allfilteredData = filters;
      const formattedStartDate = formatDateToDDMMYYYY(
        allfilteredData?.fromDate
      );
      const formattedEndDate = formatDateToDDMMYYYY(allfilteredData?.toDate);

      setLoading(true);
  
      // Fetch data from API
      const response = await axiosInstance.post(
        "/customer-po/export-customer-po-list",
        {
          startDate: formattedStartDate || null,
          endDate: formattedEndDate || null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const responseData = response?.data?.data?.data || [];
  
      if (responseData.length === 0) {
        alert("No data available to download.");
        return;
      }
  
      // Define column headers
      const headers = [
        { label: "PO Stock ID", key: "postockinsr_id" },
        { label: "PO Number", key: "po_number" },
        { label: "VIN No", key: "vin_no" },
        { label: "Chassis No", key: "chassis_no" },
        { label: "Serial No", key: "serial_no" },
        { label: "Motor No", key: "motor_no" },
        { label: "Battery No", key: "battery_no" },
        { label: "Discount Type", key: "discountType" },
        { label: "Total Price", key: "total_price" },
        { label: "Discount", key: "discount" },
        { label: "PO Date", key: "po_date" },
        { label: "Customer Delivery Date", key: "customer_delivery_date" },
        { label: "Variant Name", key: "variant_name" },
        { label: "Full Name", key: "full_name" },
        { label: "Mobile No", key: "mobile_no" },
      ];
  
      // Convert JSON data to a format suitable for the Excel file
      const formattedData = responseData.map((item) =>
        headers.map((header) => item[header.key] || "")
      );
  
      // Add headers as the first row
      const worksheetData = [headers.map((header) => header.label), ...formattedData];
  
      // Create a new workbook and worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  
      // Append worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Customer PO Data");
  
      // Generate Excel file and trigger download
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
  
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      saveAs(blob, "Customer_PO_List.xlsx");
  
    } catch (error) {
      console.error("Error fetching or downloading customer PO list:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductList(newPage);
  };

  const TABLE_HEADERS = [
    "PO No.",
    "Customer Name",
    "Mobile No.",
    "Variant Name",
    "Vin No.",
    "Serial No",
    "Battery No.",
    "Delivery Date",
    "Motor No.",
    "Total Price (₹)",
    "Action",
  ];

  const keyMapping = {
    "PO No.": "po_number",
    "Customer Name": "full_name",
    "Mobile No.": "mobile_no",
    "Variant Name": "variant_name",
    "Vin No.": "vin_no",
    "Serial No": "serial_no",
    "Battery No.": "battery_no",
    "Motor No.": "motor_no",
    "Delivery Date": "customer_delivery_date",
    "Total Price (₹)": "total_price",
    Action: [
      {
        type: "printCustomerPurchaseOrder",
        icon: download,
        label: "Print",
      },
      { type: "mail", icon: mailIcon, label: "Mail" },
    ],
    // "Action": [
    //   // { type: "edit", icon: editIcon, label: "Edit" },
    //   { type: "view", icon: eyeIcon, label: "View" },
    // ]
  };
  useEffect(() => {
    if (searchTerm === "") {
      setCurrentPage(0);
      fetchProductList(0);
    }
  }, [searchTerm]);
  const handleEdit = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.EDITPRODUCT}`, { state: { data: rowData } });
  };

  const DownLoadPdf = (row) => {
    var text = row?.postockinsr_id;
    var encoded = base64.encode(text);
    const pdfURL = `${process.env.REACT_APP_API_BASE_URL}customer-po/customer-wise-inovice/${encoded}`;
    window.open(pdfURL, "_blank", "noopener,noreferrer");
  };
  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setCurrentPage(0);
      fetchProductList(0);
    }
  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      gridClass: "col-lg-4",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      gridClass: "col-lg-4",
    },
  ];

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    setCurrentPage(0);
    fetchProductList(0);
  };

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      //   is_order_accepted:filterFormData.is_order_accepted || 0,
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
    });
  };

  useEffect(() => {
    fetchProductList(0);
  }, [filters]);

//   const handleMailFunc = async (row) => {
//     var text = row?.postockinsr_id;
//        var encoded = base64.encode(text);
//    try {
//      const response = await axiosInstance.get(
//        `/purchaseorder/attchement-send-emailto-customer/${encoded}`,
//        {
//          headers: {
//            "Content-Type": "application/json",
//            Authorization: `Bearer ${token}`,
//          },
//        }
//      );

//    } catch (error) {
//      console.error("Error fetching action taken list:", error);
//    }
//  }

const handleMailFunc = async (row) => {
  const text = row?.postockinsr_id;
  const encoded = base64.encode(text);

  try {
    const response = await axiosInstance.get(
      `/purchaseorder/attchement-send-emailto-customer/${encoded}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      await showAlert({
        title: "Success",
        text: "Email sent successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
    }

  } catch (error) {
    console.error("Error fetching action taken list:", error);
  }
};  

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div className="OnboardManagamentContainer">
              <div className="OnboardManagamentbuttonContainer">
                {/* <div style={{fontSize:"12px",color:"lightgrey"}} >Sales / Customer Purchase Order</div> */}
                <h5 style={{ fontWeight: "600", fontSize: "24px" }}>
                  Customer Retails Sales
                </h5>
              </div>
            </div>

            <div className="tableWrapper">
              <div className="admin-list-container">
                <div
                  style={{
                    paddingTop: "35px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  className="listsearchContainer"
                >
                  <h5>Order List</h5>
                  {/* <div className="searchinput-wrapper">
                    <input
                      type="text"
                      className="searchinput"
                      placeholder="Search By Dealer"
                      value={searchTerm}
                      onChange={handleSearchInputChange}
                      onKeyPress={handleKeyPress}
                    />
                    {searchTerm ? (
                      <IoMdClose
                        size={22}
                        className="searchinput-close-icon"
                        onClick={clearSearchAndFetch}
                      />
                    ) : (
                      <img
                        src={searchIcon}
                        alt="Search"
                        className="searchinput-icon"
                      />
                    )}
                  </div> */}
                  <div>
                    <SearchInput
                      placeholder="Search Name"
                      onSearch={() => { setCurrentPage(0); fetchProductList(0); }}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />

                  </div>

                </div>

                <div style={{display:"flex", justifyContent:"end", alignItems:"end",flexDirection:"column"}} >
                  <ListLogisticsFilters
                    formConfig={PhysicalStockTakingInputs}
                    formData={filterFormData}
                    setFormData={setFilterFormData}
                    validationErrors={validationErrors}
                    setValidationErrors={setValidationErrors}
                    handleSearch={handleSearch}
                    handleClear={clearFilter}
                  />
                  <button
                    onClick={downloadExcel}
                    style={{
                      paddingLeft: "45px",
                      paddingRight: "45px",
                      marginTop: "1rem",
                    }}
                    className="submit-btn order-management-details"
                  >
                    Export To Excel
                  </button>
                </div>
              </div>
              <CustomTable
                data={productData}
                headers={TABLE_HEADERS}
                keyMapping={keyMapping}
                itemsPerPage={10}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onEdit={handleEdit}
                totalRecords={totalRecords}
                pdfDownLoad={DownLoadPdf}
                handleMailFunc={handleMailFunc}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AdminCustomerPurchaseOrder;
